require('../../modules/es6.reflect.apply');
module.exports = require('../../modules/_core').Reflect.apply;



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/fn/reflect/apply.js
// module id = 958
// module chunks = 48 49 50